import { useSelector } from 'react-redux';

import {
  useGetPurchaseOrderDetailsQuery,
  useGetUnitPurchaseOrdersQuery,
} from '@modules/rtk/esb-api';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import { useGetBulkAdvancementHistoryToPurchaseQuery } from './api';
import { pendingItemsToPurchaseQueryPayloadSel } from './duck/selectorsTyped';

/**
 * Used in Purchase Order - Step #3
 */
export function useGetPurchaseOrders() {
  const selectedOrgGuid = useSelector(organizationGuidSel);

  const skip = !selectedOrgGuid;

  const response = useGetUnitPurchaseOrdersQuery(
    {
      organizationGuid: selectedOrgGuid,
      params: {
        page: 1,
        perPage: 300,
      },
    },
    { skip },
  );

  return response;
}

/**
 * Used in Purchase Order - Step #2
 */
export function usePurchaseOrderDetails(props: { purchaseOrderId: number }) {
  const selectedOrgGuid = useSelector(organizationGuidSel);
  const poid = props.purchaseOrderId;
  const skip = !selectedOrgGuid || !poid;

  const response = useGetPurchaseOrderDetailsQuery(
    {
      organizationGuid: selectedOrgGuid,
      purchaseOrderId: poid,
    },
    { skip },
  );

  return response;
}

/**
 * Used on To Purchase Tab - Section #1
 */
export function usePendingItemsToPurchaseTabQuery() {
  const arg = useSelector(pendingItemsToPurchaseQueryPayloadSel);

  const response = useGetBulkAdvancementHistoryToPurchaseQuery(arg, {
    skip: !arg.payload.body.organizationGuid,
  });

  return response;
}
